module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.145de082.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propertybooster-favicon/safari-pinned-tab.svg
// module id = 288
// module chunks = 0